module.exports = __webpack_public_path__ + "static/media/ribbon.7ba1e3fc.svg";